import { BannerService } from "../../services/bannerService";
import { HttpStatus } from "../../constant/responseStatus";
import { AssetPublishModel } from "src/models/assetModel";
import { AssetType } from "../../constant/assetConstants";
import { useEffect, useState } from "react";
import TranslationKey from "src/i18n/translation";
import JustifiedGallery from "../gallerySearch/JustifiedGallery";

interface TypeInterface {
  assetType: string;
  openTextAll?: boolean;
}

export default function GallerysTrending({
  assetType,
  openTextAll = true,
}: TypeInterface) {
  const [assets, setAssets] = useState<AssetPublishModel[]>([]);

  useEffect(() => {
    if (assetType) {
      onGetRandomAssetAsync(assetType);
    }
  }, [assetType]);

  const onGetRandomAssetAsync = async (assetType: string) => {

    const type =
      assetType !== AssetType.IMAGE && assetType !== AssetType.VIDEO
        ? undefined
        : assetType;

    const { data: responseData, status: responseStatus } =
      await new BannerService().GetRandomAsset(type);

    if (responseStatus !== HttpStatus.OK) {
      return;
    }

    setAssets(responseData.data);
  };

  return (
    <div className="box-gallery">
      {
        <>
          <JustifiedGallery assets={assets} />
          <div className="box-gradient" />
          <div className="box-gradient-end" />
        </>
      }
      {
        openTextAll &&
        <div className="view-all pt-5">
          <a className="text-light" href="/search">
            {TranslationKey('button.viewAll')}
          </a>
        </div>
      }
      <div className='box-gradient' />
      <div className='box-gradient-end' />
    </div>
  );
}
